<template>
  <div>
    <Header />
    <v-carousel cycle hide-delimiters show-arrows-on-hover height="auto">
      <v-carousel-item v-for="(item, i) in items" :key="i">
        <v-img
          :src="item.src"
          :lazy-src="require('@/assets/carruselLazyLoad.jpg')"
        >
          <template v-slot:placeholder>
            <v-progress-circular
              indeterminate
              color="grey lighten-5"
            ></v-progress-circular>
          </template>
        </v-img>
      </v-carousel-item>
    </v-carousel>

    <v-sheet height="auto" width="100%" data-aos="fade-up">
      <v-container class="pa-0" fluid>
        <v-col cols="12" class="pa-0">
          <v-row align="center" justify="center" class="ma-0 pt-3">
            <v-card
              class="ma-3 pa-6"
              style="border: 0px solid white"
              width="700"
              outlined
              tile
            >
              <div
                class="fontTitulo"
                :class="[
                  $vuetify.breakpoint.mdAndUp
                    ? 'fontTitulo'
                    : 'fontTituloResponsive',
                ]"
              >
                ¿QUIENES SOMOS?
              </div>
              <p
                class="subfont text-justify mb-0"
                :class="[
                  $vuetify.breakpoint.mdAndUp ? 'subfont' : 'subfontResponsive',
                ]"
              >
                Una asistencia con amplia cobertura a nivel Centroamericano con
                infraestructura, recursos y tecnología en cada una de nuestras
                asistencias, contamos con un equipo humano altamente calificado
                y especializado que nos permite marcar las tendencias en la
                industria multi-asistencias con innovación y capacidad creando
                un balance entre cliente y proveedores del área Centroamericana
                y México.
              </p>
            </v-card>
            <v-card outlined tile>
              <v-img
                transition="slide-x-transition"
                :src="require('@/assets/imgHome01.png')"
                :class="[
                  $vuetify.breakpoint.mdAndUp ? 'image' : 'imageResponsive',
                ]"
                :lazy-src="require('@/assets/carruselLazyLoad.jpg')"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-card>
          </v-row>
        </v-col>
      </v-container>
    </v-sheet>

    <v-img
      :src="require('@/assets/separador.png')"
      width="100%"
      height="30px"
      contain
    >
    </v-img>

    <v-sheet height="auto" width="100%" data-aos="fade-up">
      <v-container class="pa-0" fluid>
        <v-col cols="12" class="pa-0">
          <v-row align="center" justify="center" class="ma-0">
            <v-card
              class="ma-0 px-3"
              style="border: 0px solid white"
              width="700"
              outlined
              tile
            >
              <v-card-title>
                <div
                  :class="[
                    $vuetify.breakpoint.mdAndUp
                      ? 'fontTitulo'
                      : 'fontTituloResponsive',
                  ]"
                >
                  MISION
                </div>
              </v-card-title>
              <p
                class="subfont text-justify mb-0 px-3"
                :class="[
                  $vuetify.breakpoint.mdAndUp ? 'subfont' : 'subfontResponsive',
                ]"
              >
                Ser una empresa líder en el mercado multi-asistencial nacional y
                de la región centroamericana
              </p>
            </v-card>
            <v-card
              class="ma-0 px-3"
              style="border: 0px solid white"
              width="700"
              outlined
              tile
            >
              <v-card-title>
                <div
                  class="fontTitulo"
                  :class="[
                    $vuetify.breakpoint.mdAndUp
                      ? 'fontTitulo'
                      : 'fontTituloResponsive',
                  ]"
                >
                  VISION
                </div>
              </v-card-title>
              <p
                class="subfont text-justify mb-0 px-3"
                :class="[
                  $vuetify.breakpoint.mdAndUp ? 'subfont' : 'subfontResponsive',
                ]"
              >
                Ser una empresa de asistencias a nivel regional utilizando
                tecnología de vanguardia y un capital humano altamente
                calificado, que se traduce en servicio de calidad
              </p>
            </v-card>
          </v-row>
        </v-col>
      </v-container>
    </v-sheet>

    <v-img
      :src="require('@/assets/separador.png')"
      width="100%"
      height="30px"
      contain
    >
    </v-img>

    <v-sheet height="auto" width="100%" data-aos="fade-up">
      <v-container class="pa-0" fluid>
        <v-col cols="12" class="pa-0">
          <v-row align="center" justify="center" class="ma-0 pb-3">
            <v-card
              class="ma-0 px-3"
              style="border: 0px solid white"
              width="900"
              outlined
              tile
            >
              <v-card-title>
                <div
                  class="fontTitulo"
                  :class="[
                    $vuetify.breakpoint.mdAndUp
                      ? 'fontTitulo'
                      : 'fontTituloResponsive',
                  ]"
                >
                  VALORES
                </div>
              </v-card-title>
              <p
                class="subfont text-justify mb-0 px-3"
                :class="[
                  $vuetify.breakpoint.mdAndUp ? 'subfont' : 'subfontResponsive',
                ]"
              >
                Honestidad, Integridad, Responsabilidad, Solidaridad, Respeto,
                Servicio
              </p>
            </v-card>
          </v-row>
        </v-col>

        <v-img
          :src="require('@/assets/separador.png')"
          width="100%"
          height="30px"
          contain
        >
        </v-img>

        <v-col cols="12" class="pa-0">
          <v-row align="center" justify="center" class="ma-0 pb-3">
            <v-card
              class="ma-0 px-3"
              style="border: 0px solid white"
              width="900"
              outlined
              tile
            >
              <v-card-title>
                <div
                  class="fontTitulo"
                  :class="[
                    $vuetify.breakpoint.mdAndUp
                      ? 'fontTitulo'
                      : 'fontTituloResponsive',
                  ]"
                >
                  POLITICA DE CALIDAD
                </div>
              </v-card-title>
              <p
                class="subfont text-justify mb-0 px-3"
                :class="[
                  $vuetify.breakpoint.mdAndUp ? 'subfont' : 'subfontResponsive',
                ]"
              >
                Somos una empresa orientada hacia la satisfacción de nuestros
                clientes en cada atención de sus servicios, comprometidos con
                nuestros clientes corporativos a brindar un servicio
                satisfactorio. nuestro compromiso hacia nuestros clientes es la
                mejora y la innovación continua, creando un balance entre
                nuestros clientes corporativos, capital humano y proveedores de
                servicios
              </p>
            </v-card>
          </v-row>
        </v-col>
      </v-container>
    </v-sheet>

    <v-img
      :src="require('@/assets/separador.png')"
      width="100%"
      height="30px"
      contain
    >
    </v-img>

    <v-sheet height="auto" width="100%">
      <v-container class="pa-0" fluid>
        <v-col cols="12" class="pa-0">
          <v-row align="center" justify="center" class="ma-0">
            <v-card
              class="ma-0 px-3"
              style="border: 0px solid white"
              width="1000"
              outlined
              tile
            >
              <div
                class="fontTitulo text-center"
                :class="[
                  $vuetify.breakpoint.mdAndUp
                    ? 'fontTitulo'
                    : 'fontTituloResponsive',
                ]"
                data-aos="fade-up"
              >
                NUESTRA HISTORIA
              </div>
              <p
                class="subfont text-justify mb-0 px-3"
                :class="[
                  $vuetify.breakpoint.mdAndUp ? 'subfont' : 'subfontResponsive',
                ]"
                data-aos="fade-up"
              >
                Reseña histórica de asistencia regional<br /><br />

                Asistencia regional el salvador S.A de C. V. una empresa con
                capital 100% salvadoreño, nace a finales del año 2017, bajo la
                visión empresarial y la experiencia de más de una década en el
                mercado multi-asistencial de sus socios fundadores.<br /><br />

                Como todo proyecto de emprendedurismo asistencia regional en sus
                inicios se abrió camino gracias a nuestros clientes corporativos
                quienes depositaron su confianza en nuestra marca y visión de
                negocios y capacidad de respuesta y es así como empresas de
                mucho prestigio internacional nos abren sus puertas para formar
                parte de sus proveedores de servicios a nivel
                centroamericano.<br /><br />

                En asistencia regional día a día nos encargamos de unir las
                fronteras, para que los clientes puedan recibir un servicio de
                calidad en donde se encuentren, desde Guatemala hasta Panamá
                convirtiendo en cada servicio una experiencia nueva positiva.<br /><br />

                Hoy en día asistencia regional tiene alianzas con varias
                compañías de la región centroamericana y México, pero todo ha
                sido gracias al esfuerzo y entrega de cada uno de miembros del
                equipo y los proveedores quienes hacemos una gran familia.<br /><br />

                Los invito a que nos conozcan nuestra gama de servicios y juntos
                desarrollar proyectos, cuyos ejes rectores sea la confianza,
                cooperación y el crecimiento mutuo.
              </p>
            </v-card>
          </v-row>
        </v-col>
      </v-container>
    </v-sheet>

    <v-divider inset></v-divider>

    <div class="mt-3" data-aos="fade-up">
      <p
        class="fontTitulo text-center ma-0"
        :class="[
          $vuetify.breakpoint.mdAndUp ? 'fontTitulo' : 'fontTituloResponsive',
        ]"
      >
        NUESTROS CLIENTES
      </p>
    </div>

    <v-row no-gutters>
      <v-col
        cols="12"
        sm="6"
        offset-sm="3"
        class="flex-grow-1 flex-shrink-0 mx-auto"
        style="min-width: 100px; max-width: 100%"
      >
        <v-card flat tile>
          <v-container>
            <v-row>
              <v-col
                v-for="(itemcliente, n) in itemsClientes"
                :key="n"
                cols="4"
              >
                <v-hover>
                  <template v-slot:default="{ hover }">
                    <v-card flat tile :elevation="hover ? 12 : 2">
                      <v-img
                        :src="itemcliente.src"
                        class="black-text"
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color="grey lighten-5"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                        <v-row
                          align="end"
                          class="lightbox black--text pa-2 fill-height mt-3"
                        >
                          <v-col>
                            <div>{{ itemcliente.title }}</div>
                          </v-col>
                        </v-row>
                      </v-img>
                      <v-fade-transition>
                        <v-overlay
                          v-if="hover"
                          z-index="4"
                          absolute
                          color="#bedff5"
                        >
                        </v-overlay>
                      </v-fade-transition>
                    </v-card>
                  </template>
                </v-hover>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <div class="mt-3" data-aos="fade-up">
      <p
        class="fontTitulo text-center ma-0"
        :class="[
          $vuetify.breakpoint.mdAndUp ? 'fontTitulo' : 'fontTituloResponsive',
        ]"
      >
        NUESTRA COBERTURA ACTUAL
      </p>
    </div>

    <v-container class="mb-12">
      <v-row>
        <v-col cols="12" md="7">
          <div
            id="mapContainer"
            class="mx-auto mt-5"
            style="max-width: 550px; height: 500px"
          ></div>
        </v-col>

        <v-col cols="12" md="5">
          <v-card
            max-width="375"
            class="
              mx-auto
              md-medium-size-33 md-small-size-50 md-xsmall-size-100
            "
          >
            <v-img :src="require('@/assets/logo.jpg')" contain dark> </v-img>

            <v-list>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>EL SALVADOR </v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="FlyTo(1)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>

              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>GUATEMALA</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="FlyTo(2)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>

              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>HONDURAS</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="FlyTo(3)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>

              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>NICARAGUA</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="FlyTo(4)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>

              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>COSTA RICA </v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="FlyTo(5)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>

              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>PANAMA </v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="FlyTo(6)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <ButtonScroll />
    <Footer />
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import ButtonScroll from "../components/ButtonScroll.vue";
import mapboxgl from "mapbox-gl";

export default {
  name: "home",
  components: {
    Header,
    Footer,
    ButtonScroll,
  },
  data: () => ({
    //imagenes de carrusel
    items: [
      {
        src: require("@/assets/carrusel_01.jpg"),
      },
      {
        src: require("@/assets/carrusel_02.jpg"),
      },
      {
        src: require("@/assets/carrusel_03.jpg"),
      },
    ],
    //imagenes para clientes
    itemsClientes: [
      {
        title: "",
        src: require("@/assets/cliente11.jpg"),
      },
      {
        title: "",
        src: require("@/assets/cliente01.jpg"),
      },
      {
        title: "",
        src: require("@/assets/cliente02.jpg"),
      },
      {
        title: "",
        src: require("@/assets/cliente03.jpg"),
      },
      {
        title: "",
        src: require("@/assets/cliente04.jpg"),
      },
      {
        title: "",
        src: require("@/assets/cliente05.jpg"),
      },
      {
        title: "",
        src: require("@/assets/cliente06.jpg"),
      },
      {
        title: "Banco Agromercantil",
        src: require("@/assets/cliente07.jpg"),
      },
      {
        title: "",
        src: require("@/assets/cliente08.jpg"),
      },
      {
        title: "",
        src: require("@/assets/cliente09.jpg"),
      },
      {
        title: "El Salvador",
        src: require("@/assets/cliente10.jpg"),
      },
      {
        title: "Costa Rica",
        src: require("@/assets/cliente10.jpg"),
      },
      {
        title: "México",
        src: require("@/assets/cliente10.jpg"),
      },
    ],
    overlay: false,
    map: "",
    accessToken:
      "pk.eyJ1Ijoiam9obmxpbmFyZXMiLCJhIjoiY2tjcWk2eDZrMTU2bjJyczVyMWF0ejg3NiJ9.848u9JaZDYfKTRPBzFvDwA",
    marcadores: [
      {
        id: 1,
        titulo: "EL SALVADOR",
        coordenadas: [-89.24173, 13.699239],
        icono: "",
      },
      {
        id: 2,
        titulo: "GUATEMALA",
        coordenadas: [-90.332182, 15.03393],
        icono: "",
      },
      {
        id: 3,
        titulo: "HONDURAS",
        coordenadas: [-86.589205, 14.787629],
        icono: "",
      },
      {
        id: 4,
        titulo: "NICARAGUA",
        coordenadas: [-85.146837, 12.824656],
        icono: "",
      },
      {
        id: 5,
        titulo: "COSTA RICA",
        coordenadas: [-84.091445, 9.804338],
        icono: "",
      },
      {
        id: 6,
        titulo: "PANAMA",
        coordenadas: [-80.221676, 8.88073],
        icono: "",
      },
    ],
  }),

  mounted() {
    mapboxgl.accessToken = this.accessToken;
    this.map = new mapboxgl.Map({
      container: "mapContainer",
      style: "mapbox://styles/mapbox/streets-v11",
      center: [-85.481089, 12.095187],
      zoom: 5,
    });
    for (var i = 0; i < this.marcadores.length; i++) {
      var marker = new mapboxgl.Marker({ color: "blue" })
        .setLngLat(this.marcadores[i].coordenadas)
        .setPopup(
          new mapboxgl.Popup({ offset: 25 }).setHTML(
            "<strong>" + this.marcadores[i].titulo + "</strong>"
          )
        )
        .addTo(this.map);
    }
    this.map.addControl(new mapboxgl.FullscreenControl());
    this.map.addControl(
      new mapboxgl.GeolocateControl({
        positionOptions: {
          enableHighAccuracy: true,
        },
        trackUserLocation: true,
      })
    );
    this.map.addControl(new mapboxgl.NavigationControl());
  },
  methods: {
    FlyTo(i) {
      switch (i) {
        case 1:
          var center = this.marcadores[i - 1].coordenadas;
          break;
        case 2:
          var center = this.marcadores[i - 1].coordenadas;
          break;
        case 3:
          var center = this.marcadores[i - 1].coordenadas;
          break;
        case 4:
          var center = this.marcadores[i - 1].coordenadas;
          break;
        case 5:
          var center = this.marcadores[i - 1].coordenadas;
          break;
        case 6:
          var center = this.marcadores[i - 1].coordenadas;
          break;
      }
      this.map.flyTo({
        center: center,
        zoom: 7,
        bearing: 0,
        speed: 0.4,
        curve: 1,
        easing: function (t) {
          return t;
        },
        essential: true,
      });
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Zilla+Slab:ital,wght@1,700&display=swap");
@import url("https://fonts.googleapis.com/css2?family=EB+Garamond:wght@500&family=Zilla+Slab:ital,wght@1,700&display=swap");

.fontTitulo {
  font-family: "Zilla Slab", serif;
  font-size: 35px;
}
.fontTituloResponsive {
  font-family: "Zilla Slab", serif;
  font-size: 20px;
}
.subfont {
  font-family: "EB Garamond", serif;
  font-size: 25px;
}
.subfontResponsive {
  font-family: "EB Garamond", serif;
  font-size: 15px;
}
.image {
  width: 450px;
  height: 400px;
}
.imageResponsive {
  width: 250px;
  height: 250px;
}
</style>
